import React, { PropsWithChildren } from "react"
import * as Components from "../../components/components"
import { EventBus } from "../../eventbus"
import { Anlage } from "../../models/anlage"
import { DateiAnlage } from "../../models/dateianlage"
import { NoState } from "../../models/interfaces"
import { UploadAnlage } from "../../models/uploadanlage"
import { UrlAnlage } from "../../models/urlanlage"

interface AnlageWrapperViewProps {
    index: number
    anlage: Anlage
    t?: any
}

export class AnlageWrapperView extends React.Component<PropsWithChildren<AnlageWrapperViewProps>, NoState> {
    onRemoveClicked = () => {
        EventBus.instance.emit("removeAnlage", this.props.index)
    }

    onChange(property: string, value: string) {
        EventBus.instance.emit("changeProperty", `anlagen.${this.props.index}.${property}`, value)
    }

    getName(anlage: Anlage) {
        const { t } = this.props
        if (anlage instanceof UrlAnlage) return t("rechnung.anlagen.urlAnlage.title")
        if (anlage instanceof DateiAnlage) return t("rechnung.anlagen.dateiAnlage.title")
        if (anlage instanceof UploadAnlage) return t("rechnung.anlagen.dateiAnlage.titleUpload")
        return t("rechnung.anlagen.unbekannt.title")
    }

    render() {
        const { t } = this.props
        return (
            <div className="anlage">
                <Components.Row>
                    <Components.Col size={8}>
                        <h5>{this.getName(this.props.anlage)}</h5>
                    </Components.Col>
                    <Components.Col size={4} align={Components.Align.RIGHT}>
                        <Components.Button label={t("rechnung.anlagen.entfernen")} onClick={this.onRemoveClicked} style={Components.ButtonStyle.SECONDARY} />
                    </Components.Col>
                </Components.Row>

                {this.props.children}

                <Components.Row>
                    <Components.Col size={12}>
                        <Components.FormGroup label={t("rechnung.anlagen.name")} inline={true} labelClassName="small">
                            <Components.TextEdit value={this.props.anlage.name} onChange={this.onChange.bind(this, "name")} />
                        </Components.FormGroup>
                    </Components.Col>
                </Components.Row>

                <Components.Row>
                    <Components.Col size={12}>
                        <Components.FormGroup label={t("rechnung.anlagen.beschreibung")} inline={true} labelClassName="small">
                            <Components.TextEdit value={this.props.anlage.beschreibung} multiline={true} onChange={this.onChange.bind(this, "beschreibung")} />
                        </Components.FormGroup>
                    </Components.Col>
                </Components.Row>
            </div>
        )
    }
}
